import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
import './plugins/element.js'
import Print from './utils/print.js';
Vue.use(Print);
import Region from 'v-region'
Vue.use(Region);
import { RegionSelects } from 'v-region'
Vue.component('v-region-selects', RegionSelects)

Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/api'
Axios.defaults.headers.post['Content-Type'] = 'application/json';
Axios.defaults.headers.common['Authorization'] = store.getters.getToken;
Axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return Promise.resolve({ data: { header: { status: -1, msg_cd: '999999', msg: '系统错误' } } });
      // 返回401，清除token信息并跳转到登录页面
      case 401:
        store.commit("logout")
        router.replace({
          path: '/supplier'
          //登录成功后跳入浏览的当前页面
          // query: {redirect: router.currentRoute.fullPath}
        })
    }
    // 返回接口返回的错误信息
    return Promise.reject(error.response.data);
  }
});

Vue.config.productionTip = false

// 设置cookie
Vue.prototype.setCookie = function (name, value, day) {
  /*
  * 使用
  * this.setCookie("XXXX",res.token);
  */
  var Days = day || 365;    //这里设置天数
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  // document.cookie = name + "="+ escape (value) + ";domain=(这里可以放入指定使用的域名);expires=" + exp.toGMTString();
}
// 获取cookie
Vue.prototype.getCookie = function (name) {
  /*
  * 使用
  * console.log(this.getCookie("XXX"))
  */
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}
// 删除cookie
Vue.prototype.delCookie = function (name) {
  /*
  * 使用
  * this.delCookie("XXX")
  */
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = this.getCookie(name);
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}

const formatToFixed = (money, decimals = 2) => {
  return (
    Math.round((parseFloat(money) + Number.EPSILON) * Math.pow(10, decimals)) /
    Math.pow(10, decimals)
  ).toFixed(decimals);
};

Vue.prototype.MoneyFormat = (money, symbol = "", decimals = 2) => `${symbol}${parseFloat(formatToFixed(money, decimals)).toLocaleString(
  "zh",
  {
    maximumFractionDigits: decimals,
    useGrouping: true,
  }
)}`;

Vue.prototype.getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

router.beforeEach((to, from, next) => {
  if (to.path != "/" && !store.getters.isLogin) {
    next("/")
  } else {
    next()
  }
})

router.ber

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this//安装全局事件总线
  },
  created() {
    this.$store.state.clientHeight = document.body.clientHeight;
    window.onresize = () => {
      this.$store.state.clientHeight = document.body.clientHeight;
    }
  }
}).$mount('#app')

